import React, { useContext, useEffect, useState } from 'react';
import { Nav, Tab } from "react-bootstrap";
import { useParams } from 'react-router';
import Breadcrumb from './Managment-list/Breadcrumb';




import { useHistory } from "react-router-dom";

import SucessToast from '../../MySections/Toasts/SucessToast';
// import TabPageDetails from '../compsForAllPages/TabPageDetails';
// import TabHPDetails from '../parts/TabHPDetails';
// import TabMainRests from '../parts/TabMainRests';
// import TabFavoRests from '../parts/TabFavoRests';
import utilsLinks from '../../../MyConns/_Utils/utilsLinks';
import utilsMaster from '../../../MyConns/_Utils/utilsMaster';
import { LinksContext } from '../../MyContexts/Links_Context';
import { TheMasterContext } from '../../MyContexts/Master_Context';
import TabSiteDetails from './Managment-list/TabSiteDetails';
import TabSiteLinks from './Managment-list/TabSiteLinks';
import TableManagmentSet from './Managment-list/TableManagmentSet';
import TabContactMsgs from './Managment-list/TabContactMsgs';



const ManagmentPSet = (props) => {
    const history = useHistory();

    const [theMaster, setTheMaster] = useContext(TheMasterContext);
    const [Links, setLinks] = useContext(LinksContext);

    const [loading, setLoading] = useState(false);
    let idParam = useParams();
    const [thePopUp, setThePopUp] = useState("");

    useEffect(() => {

    }, [])

    

    const updateMaster = async () => {
        let mst = await utilsMaster.updateTheMaster(theMaster);
        // setRest(rstLst);
        setTheMaster({ ...theMaster })

        let lnks = await utilsLinks.updateLinks(Links);


        SucessToast({ position: "toast-bottom-right", text: "עודכן בהצלחה!" });
    }

    return (
        <div className="ms-content-wrapper SetBlock">
            <Breadcrumb />
            {/* Active Orders Graph */}
            <div className="row">
                <div className="col-xl-12">
                    <div className="ms-panel">
                        <div className="ms-panel-header">
                            <div><h6>הגדרות</h6></div>
                        </div>
                        {loading ? "loading" :
                            <div className="col-md-12">

                                <div className="ms-panel-body clearfix">
                                    <Tab.Container defaultActiveKey="tab1">
                                        <Nav variant="tabs" className="nav nav-tabs d-flex nav-justified mb-2">
                                            <Nav.Item>
                                                <Nav.Link eventKey="tab1">פרטים להתראות</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="tab2">מסגרת</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="tab3">קישורים</Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item>
                                                <Nav.Link eventKey="tab4">שולחנות</Nav.Link>
                                            </Nav.Item> */}

                                        </Nav>
                                        <Tab.Content>
                                            {/*פרטי קשר להתראות*/}
                                            <Tab.Pane eventKey="tab1">
                                                <div className="form-row tabsInputs ">
                                                    <TabContactMsgs />
                                                </div>
                                            </Tab.Pane>
                                            {/*מסגרת*/}
                                            <Tab.Pane eventKey="tab2">
                                                <div className="form-row tabsInputs ">
                                                    <TabSiteDetails />
                                                </div>
                                            </Tab.Pane>
                                            {/* קישורים*/}
                                            <Tab.Pane eventKey="tab3">
                                                <div className="form-row tabsInputs ">
                                                    <TabSiteLinks />
                                                </div>
                                            </Tab.Pane>
                                            {/* שולחנות*/}
                                            {/* <Tab.Pane eventKey="tab4">
                                                <div className="form-row tabsInputs ">
                                                    <TableManagmentSet />
                                                </div>
                                            </Tab.Pane> */}

                                        </Tab.Content>
                                    </Tab.Container>
                                </div>



                            </div>}
                    </div>
                </div>
            </div>
            <div className="ms-panel-header approveLine">
                <button type="button" className="onLeft btn btn-primary" onClick={() => updateMaster()}>שמור</button>
            </div>
            {thePopUp}
        </div>
    );
}


export default ManagmentPSet;